import { create } from 'zustand';
import { iDatePickerState, initialDatePickerStateValues } from './models';

export const useDatePickerStore = create<iDatePickerState>()((set, get) => ({
  ...initialDatePickerStateValues,
  SetCustomMonthYearSelected: (selection) => {
    set({ customMonthYearSelected: selection });
  }
}));
